const headRowsTableMaintenances = {
  id: 'ID',
  equipment: 'Equipo',
  createdAt: 'Criada em',
  sendToMaintenanceDate: 'Fecha de Envío',
  returnFromMaintenanceDate: 'Fecha de Retorno',
  warrantyDate: 'Plazo de Garantía',
  expirationDate: 'Plazo de Validez',
  place: 'Lugar',
  amount: 'Valor',
  status: 'Status'
};

export default headRowsTableMaintenances;
